const cropData = {
  rice: {
    soil: "Alluvial soil rich in organic matter",
    duration: "120 - 150 Days",
    water: "High — Continuous flooding needed",
    cost: "₹40,000 - ₹70,000 per acre",
    temperature: "20 - 28",
    humidity: "85 - 95",
    ph: "5.5 - 6.5",
    rainfall: "200 - 300",
    fertilizers: "Urea, DAP",
    disease: "Brown Spot, Blast",
    disease_control: "Copper fungicides, avoid water logging",
    season: "Kharif (June - Nov)",
    top_states: "Punjab, Uttar Pradesh, West Bengal, Andhra Pradesh",
  },

  maize: {
    soil: "Loamy & well-drained soil",
    duration: "90 - 110 Days",
    water: "Medium water requirement",
    cost: "₹30,000 - ₹55,000 per acre",
    temperature: "18 - 27",
    humidity: "50 - 75",
    ph: "5.5 - 7.0",
    rainfall: "50 - 75",
    fertilizers: "NPK 75:40:40",
    disease: "Downy mildew, stalk rot",
    disease_control: "Seed treatment, crop rotation",
    season: "Kharif / Rabi",
    top_states: "Karnataka, Madhya Pradesh, Bihar, Telangana",
  },

  chickpea: {
    soil: "Sandy loam soil",
    duration: "100 - 120 Days",
    water: "Low — mostly rainfed conditions",
    cost: "₹28,000 - ₹50,000 per acre",
    temperature: "15 - 30",
    humidity: "50 - 60",
    ph: "6.0 - 7.0",
    rainfall: "40 - 60",
    fertilizers: "DAP + NPK",
    disease: "Fusarium wilt",
    disease_control: "Use resistant varieties",
    season: "Rabi",
    top_states: "Madhya Pradesh, Maharashtra, Rajasthan, Uttar Pradesh",
  },

  kidneybeans: {
    soil: "Well-drained loam",
    duration: "110 - 140 Days",
    water: "Medium — avoid waterlogging",
    cost: "₹45,000 - ₹65,000 per acre",
    temperature: "18 - 24",
    humidity: "60 - 70",
    ph: "6.0 - 7.5",
    rainfall: "60 - 120",
    fertilizers: "Organic compost",
    disease: "Rust, blight",
    disease_control: "Proper spacing + neem spray",
    season: "Summer / Kharif",
    top_states: "Jammu & Kashmir, Himachal Pradesh, Uttarakhand",
  },

  pigeonpeas: {
    soil: "Loamy to black cotton soil",
    duration: "160 - 200 Days",
    water: "Low to medium — drought tolerant",
    cost: "₹30,000 - ₹55,000 per acre",
    temperature: "20 - 35",
    humidity: "60 - 70",
    ph: "6.0 - 7.5",
    rainfall: "60 - 150",
    fertilizers: "DAP + FYM",
    disease: "Wilt",
    disease_control: "Crop rotation",
    season: "Kharif",
    top_states: "Maharashtra, Karnataka, Uttar Pradesh, Madhya Pradesh",
  },

  mothbeans: {
    soil: "Sandy soil",
    duration: "60 - 70 Days",
    water: "Very low — drought resistant",
    cost: "₹20,000 - ₹30,000 per acre",
    temperature: "25 - 35",
    humidity: "40 - 60",
    ph: "7.0 - 8.5",
    rainfall: "30 - 50",
    fertilizers: "Minimal fertilizers",
    disease: "Powdery mildew",
    disease_control: "Sulfur spray",
    season: "Kharif",
    top_states: "Rajasthan, Gujarat",
  },

  mungbean: {
    soil: "Black or loamy soil",
    duration: "60 - 80 Days",
    water: "Low water requirement",
    cost: "₹25,000 - ₹45,000 per acre",
    temperature: "25 - 30",
    humidity: "60 - 70",
    ph: "6.2 - 7.2",
    rainfall: "60 - 100",
    fertilizers: "DAP + compost",
    disease: "Leaf spot",
    disease_control: "Copper spray",
    season: "Kharif / Summer",
    top_states: "Rajasthan, Maharashtra, Karnataka, Tamil Nadu",
  },

  blackgram: {
    soil: "Fertile loam & clay loam",
    duration: "70 - 90 Days",
    water: "Low — rainfed",
    cost: "₹24,000 - ₹40,000 per acre",
    temperature: "25 - 35",
    humidity: "60 - 80",
    ph: "6.0 - 7.5",
    rainfall: "70 - 90",
    fertilizers: "Organic manure",
    disease: "Anthracnose",
    disease_control: "Seed treatment with Bavistin",
    season: "Kharif",
    top_states: "Uttar Pradesh, Maharashtra, Madhya Pradesh",
  },

  lentil: {
    soil: "Clay loam soil",
    duration: "100 - 120 Days",
    water: "Low water requirement",
    cost: "₹22,000 - ₹42,000 per acre",
    temperature: "15 - 25",
    humidity: "50 - 60",
    ph: "6.0 - 7.5",
    rainfall: "40 - 60",
    fertilizers: "DAP",
    disease: "Wilt",
    disease_control: "Good drainage",
    season: "Rabi",
    top_states: "Madhya Pradesh, Uttar Pradesh, Bihar",
  },

  pomegranate: {
    soil: "Sandy loam soil",
    duration: "150 - 180 Days",
    water: "Medium water need",
    cost: "₹1,00,000 - ₹1,50,000 per acre",
    temperature: "25 - 35",
    humidity: "50 - 60",
    ph: "6.0 - 7.5",
    rainfall: "50 - 100",
    fertilizers: "NPK + Calcium",
    disease: "Fruit rot",
    disease_control: "Copper oxychloride spray",
    season: "Year-round",
    top_states: "Maharashtra, Karnataka, Gujarat",
  },

  banana: {
    soil: "Well-drained loam",
    duration: "300 - 450 Days",
    water: "Very High — Regular irrigation",
    cost: "₹1,20,000 - ₹2,50,000 per acre",
    temperature: "24 - 30",
    humidity: "80 - 90",
    ph: "6.5 - 7.0",
    rainfall: "100 - 150",
    fertilizers: "FYM + NPK",
    disease: "Panama wilt",
    disease_control: "Bio-control + drip irrigation",
    season: "All seasons",
    top_states: "Tamil Nadu, Maharashtra, Gujarat, Andhra Pradesh",
  },

  mango: {
    soil: "Red & laterite soil",
    duration: "3 - 5 Years to full growth",
    water: "Medium — not waterlogged",
    cost: "₹1,00,000+ per acre (initial)",
    temperature: "24 - 30",
    humidity: "60 - 75",
    ph: "5.5 - 7.5",
    rainfall: "75 - 250",
    fertilizers: "FYM + NPK",
    disease: "Powdery mildew",
    disease_control: "Fungicidal spray",
    season: "Summer harvest",
    top_states: "Uttar Pradesh, Andhra Pradesh, Telangana, Karnataka",
  },

  grapes: {
    soil: "Sandy loam + good drainage",
    duration: "180 - 200 Days",
    water: "High — regular irrigation",
    cost: "₹2,00,000 - ₹4,00,000 per acre",
    temperature: "15 - 35",
    humidity: "60 - 70",
    ph: "6.5 - 7.0",
    rainfall: "40 - 60",
    fertilizers: "Potassium rich fertilizer",
    disease: "Downy mildew",
    disease_control: "Metalaxyl spray",
    season: "Winter season",
    top_states: "Maharashtra, Karnataka, Tamil Nadu",
  },

  watermelon: {
    soil: "Sandy loam",
    duration: "70 - 100 Days",
    water: "Medium — avoid standing water",
    cost: "₹35,000 - ₹60,000 per acre",
    temperature: "22 - 32",
    humidity: "50 - 65",
    ph: "6.0 - 7.5",
    rainfall: "50 - 75",
    fertilizers: "NPK + Potash",
    disease: "Fusarium wilt",
    disease_control: "Crop rotation",
    season: "Summer",
    top_states: "Karnataka, Tamil Nadu, Maharashtra",
  },

  muskmelon: {
    soil: "Sandy soil",
    duration: "75 - 90 Days",
    water: "Medium",
    cost: "₹30,000 - ₹50,000 per acre",
    temperature: "18 - 30",
    humidity: "50 - 60",
    ph: "6.0 - 7.0",
    rainfall: "50 - 75",
    fertilizers: "Compost + NPK",
    disease: "Powdery mildew",
    disease_control: "Sulfur spray",
    season: "Summer",
    top_states: "Uttar Pradesh, Punjab, Haryana",
  },

  apple: {
    soil: "Sandy loam + hilly",
    duration: "2 - 4 Years",
    water: "Low to Medium",
    cost: "₹3,00,000+ per acre",
    temperature: "5 - 22",
    humidity: "40 - 60",
    ph: "6.0 - 7.0",
    rainfall: "100 - 150",
    fertilizers: "FYM + NPK",
    disease: "Apple scab",
    disease_control: "Captan spray",
    season: "Cool winter",
    top_states: "Jammu & Kashmir, Himachal Pradesh, Uttarakhand",
  },

  orange: {
    soil: "Well-drained light soil",
    duration: "180 - 200 Days",
    water: "Medium",
    cost: "₹80,000 - ₹1,50,000 per acre",
    temperature: "15 - 30",
    humidity: "50 - 70",
    ph: "6.0 - 7.5",
    rainfall: "75 - 100",
    fertilizers: "FYM + Urea",
    disease: "Citrus canker",
    disease_control: "Copper spray",
    season: "Winter harvest",
    top_states: "Maharashtra, Punjab, Rajasthan, Madhya Pradesh",
  },

  papaya: {
    soil: "Sandy loam soil",
    duration: "8 - 10 Months",
    water: "High — regular irrigation",
    cost: "₹60,000 - ₹1,20,000 per acre",
    temperature: "22 - 30",
    humidity: "70 - 80",
    ph: "6.0 - 6.5",
    rainfall: "150 - 200",
    fertilizers: "NPK + organic",
    disease: "Papaya ring spot virus",
    disease_control: "Rogueing + Vector control",
    season: "All seasons",
    top_states: "Andhra Pradesh, Gujarat, Maharashtra, Tamil Nadu",
  },

  coconut: {
    soil: "Red sandy loam",
    duration: "6 - 10 Years",
    water: "High — coastal rainfed",
    cost: "₹80,000+ per acre initial",
    temperature: "27 - 32",
    humidity: "70 - 80",
    ph: "5.5 - 7.0",
    rainfall: "100 - 200",
    fertilizers: "Organic manure + Potash",
    disease: "Bud rot",
    disease_control: "Bordeaux mixture",
    season: "All seasons",
    top_states: "Kerala, Tamil Nadu, Karnataka",
  },

  cotton: {
    soil: "Black cotton soil",
    duration: "150 - 180 Days",
    water: "Medium",
    cost: "₹50,000 - ₹90,000 per acre",
    temperature: "25 - 35",
    humidity: "60 - 85",
    ph: "6.0 - 7.5",
    rainfall: "50 - 100",
    fertilizers: "Nitrogen & Potash rich",
    disease: "Wilt, bollworm",
    disease_control: "Neem oil + Bt spray",
    season: "Kharif",
    top_states: "Punjab, Gujarat, Telangana, Maharashtra",
  },

  jute: {
    soil: "Alluvial soil",
    duration: "120 - 150 Days",
    water: "High — monsoon",
    cost: "₹45,000 - ₹70,000 per acre",
    temperature: "24 - 35",
    humidity: "70 - 90",
    ph: "6.5 - 7.5",
    rainfall: "150 - 200",
    fertilizers: "Compost + NPK",
    disease: "Stem rot",
    disease_control: "Copper spray",
    season: "Monsoon",
    top_states: "West Bengal, Bihar, Assam",
  },

  coffee: {
    soil: "Well-drained red soil",
    duration: "3 - 4 Years",
    water: "High — shade required",
    cost: "₹2,00,000+ per acre",
    temperature: "15 - 28",
    humidity: "70 - 90",
    ph: "6.0 - 6.5",
    rainfall: "150 - 250",
    fertilizers: "Organic + NPK",
    disease: "Leaf rust",
    disease_control: "Copper oxychloride",
    season: "Winter flowering",
    top_states: "Karnataka, Kerala, Tamil Nadu",
  },
};

export default cropData;
